import React, { useEffect } from 'react';

const ThemeRandomizer = () => {
  useEffect(() => {
    const classes = ['darkblue-theme', 'Maroon-theme', 'DarkPurple-theme', 'indigo-theme', 'blue-theme', 'pink-theme'];
    const randomIndex = Math.floor(Math.random() * classes.length);
    const selectedClass = classes[randomIndex];

    document.body.className = selectedClass;
  }, []);

  return null; // This component doesn't render anything
};

export default ThemeRandomizer;
